import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import * as routes from 'core/routing/constants/index'
import ReactRouterPropTypes from 'react-router-prop-types'
import { ButtonPrimary } from 'core/components/ui'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { errorInfo: null }
  }

  /*static getDerivedStateFromError(error) {
    console.log(error)
    // Update state so the next render will show the fallback UI.
    return { errorInfo: true }
  }*/

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      errorInfo
    })
    // You can also log error messages to an error reporting service here
  }

  render() {
    const { errorInfo } = this.state
    const { children, history } = this.props

    if (errorInfo) {
      // Error path
      return (
        <div style={{ padding: '250px' }}>
          <h2>
            <FormattedMessage id="error-boundary-title" />
          </h2>
          <h3>
            <FormattedMessage id="error-boundary-subtitle" />
          </h3>
          <div style={{ margin: '20px 0 15px ' }}>
            <ButtonPrimary
              onClick={() => history.push(routes.HOME)}
              data-test="configurator-brands-list-back-button"
            >
              <FormattedMessage id="ui-button-back" />
            </ButtonPrimary>
          </div>
        </div>
      )
    }

    /*
    <details style={{ whiteSpace: 'pre-wrap' }}>
            {error && error.toString()}
            <br />
            {errorInfo.componentStack}
          </details>
    */

    // Normally, just render children
    return children
  }
}

ErrorBoundary.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  children: PropTypes.node.isRequired
}

export default withRouter(ErrorBoundary)
